import { useEffect, useRef, useCallback } from "react";

const IDLE_EVENTS: (keyof WindowEventMap)[] = [
  "mousemove",
  "keydown",
  "mousedown",
  "touchstart",
  "scroll",
  "click",
];

const WARN_MS = 55 * 60 * 1000;
const LOGOUT_MS = 60 * 60 * 1000;

/** Fires onWarn at 55 min of idle, onLogout at 60 min. Any user activity resets both timers. */
export function useIdleTimer(onWarn: () => void, onLogout: () => void) {
  const warnRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const logoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const reset = useCallback(() => {
    if (warnRef.current) clearTimeout(warnRef.current);
    if (logoutRef.current) clearTimeout(logoutRef.current);
    warnRef.current = setTimeout(onWarn, WARN_MS);
    logoutRef.current = setTimeout(onLogout, LOGOUT_MS);
  }, [onWarn, onLogout]);

  useEffect(() => {
    reset();
    IDLE_EVENTS.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    return () => {
      if (warnRef.current) clearTimeout(warnRef.current);
      if (logoutRef.current) clearTimeout(logoutRef.current);
      IDLE_EVENTS.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [reset]);
}
